import { FC } from 'react';
import ISvgProps from '../SvgLoader/ISvgProps';

export const BackIcon: FC<ISvgProps> = ({ primaryColor = '#191919' }) => {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_19_1905)">
				<path
					d="M7.24216 8L10.7778 11.8891L9.7678 13L5.22222 8L9.7678 3L10.7778 4.11094L7.24216 8Z"
					fill={primaryColor}
				/>
			</g>
			<defs>
				<clipPath id="clip0_19_1905">
					<rect width="10" height="9.55556" fill="white" transform="translate(3.22223 13) rotate(-90)" />
				</clipPath>
			</defs>
		</svg>
	);
};
